import { useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"

import PageHeader from "../../components/PageHeader"
import { apiBaseURI } from "../../config"
import { fetchPageContent } from "../../features/alumni-database/alumniDatabaseSlice"
import About from "./About"
import DatabaseWrapper from "./DatabaseWrapper"
import "./alumni-database.css"

const AlumniDatabase = () => {
    const dispatch = useDispatch()

    const { pageContent } = useSelector((state) => state.alumniDatabasePage)

    useEffect(() => {
        dispatch(fetchPageContent("alumni-database"))
    }, [dispatch])

    return (
        <>
            <PageHeader
                text={false}
                image={`${apiBaseURI}${pageContent.image_url}`}
            />
            <About about={pageContent.content} />
            <DatabaseWrapper />
        </>
    )
}

export default AlumniDatabase
